import React from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, FormButtons, FormControl, TextControl } from '@clatter/ui';
import {
  createBioGroup,
  updateBioGroup,
} from '../../../store/bio-groups.slice';

const StyledBioGroupForm = styled.form`
  width: 480px;
`;

const BioGroupForm = ({ editableItem, isEdit, onSuccess }) => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    formState,
  } = useForm({
    mode: 'onChange',
    defaultValues: editableItem,
  });

  const onSubmit = async (formData) => {
    dispatch(
      isEdit
        ? updateBioGroup({ id: editableItem.id, formData })
        : createBioGroup(formData),
    ).then(() => {
      onSuccess();
    });
  };

  return (
    <StyledBioGroupForm onSubmit={handleSubmit(onSubmit)}>
      <FormControl label="Group name" error={errors.groupName}>
        <TextControl
          {...register('groupName', {
            required: { value: true, message: 'Field is required' },
          })}
          placeholder="Enter group name"
        />
      </FormControl>
      <FormButtons>
        <Button
          disabled={!formState.isValid || !formState.isDirty}
          type="submit"
        >
          {isEdit ? 'Save' : 'Create'}
        </Button>
      </FormButtons>
    </StyledBioGroupForm>
  );
};

export default BioGroupForm;
